module.exports = __webpack_public_path__ + "img/lib_region_flag_us.3231b8c7.png";